import { Component, ElementRef, Input, OnDestroy, Type } from '@angular/core';
import { has as _has } from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { LoadingSpinnerService } from '../../services/loading-spinner.service';

@Component({
  selector: 'drp-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  standalone: false
})
export class LoadingSpinnerComponent implements OnDestroy {
  public active: boolean;
  public loadingMessage: string;
  public secondaryMessage: string;
  public blockActions: boolean;
  public maxWidth: string;
  private el: any;
  private stop$ = new Subject<void>();

  @Input() show: boolean;

  constructor(
    spinner: LoadingSpinnerService,
    private elRef: ElementRef
  ) {
    spinner.status.pipe(takeUntil(this.stop$)).subscribe((status: boolean) => {
      if (this.show) {
        this.active = status;
      } else {
        this.active = status;
      }
    });

    spinner.blockActionsStatus.pipe(takeUntil(this.stop$)).subscribe((status: boolean) => {
      this.blockActions = status;
      this.el = this.elRef; // This element

      if (_has(this.el, 'nativeElement')) {
        if (this.blockActions) {
          this.el.nativeElement.classList.add('actionBlock');
        } else {
          this.el.nativeElement.classList.remove('actionBlock');
        }
      }
    });

    spinner.loadingMessageSub
      .pipe(takeUntil(this.stop$))
      .subscribe((loadingMessageContent: string) => {
        if (loadingMessageContent) {
          this.loadingMessage = loadingMessageContent;
        }
      });

    spinner.secondaryMessageSub
      .pipe(takeUntil(this.stop$))
      .subscribe((secondaryMessageContent: string) => {
        if (secondaryMessageContent) {
          this.secondaryMessage = secondaryMessageContent;
        }
      });

    spinner.maxWidthSub.pipe(takeUntil(this.stop$)).subscribe((maxWidthContent: string) => {
      if (maxWidthContent) {
        this.maxWidth = maxWidthContent;
      }
    });
  }

  ngOnDestroy() {
    this.stop$.next();
    this.stop$.complete();
  }
}
